/**
 * Suteraa PDP AOV stacking — Add and save (FBT) + post-ATC extras.
 * Fashion-branded add-and-save + post-ATC upsells; GMC-safe live prices.
 */
(function () {
  'use strict';

  var ADDON_MAX_CENTS = 4900;
  var BUNDLE_TIERS = [
    { min: 2, pct: 10 },
    { min: 3, pct: 15 },
    { min: 4, pct: 25 }
  ];

  function money(cents) {
    var n = Math.round(Number(cents) || 0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var fmt = (window.theme && theme.moneyFormat) ||
        (window.Shopify.currency && Shopify.currency.active === 'USD' ? '${{amount}}' : null) ||
        '${{amount}}';
      try { return Shopify.formatMoney(n, fmt); } catch (e) { /* fall through */ }
    }
    return '$' + (n / 100).toFixed(2);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function getSizedImage(src, size) {
    if (!src) return '';
    var s = String(src);
    if (s.indexOf('//') === 0) s = window.location.protocol + s;
    if (size && /(\.[a-z]+)(\?|$)/i.test(s)) {
      return s.replace(/(\.[a-z]+)(\?|$)/i, '_' + size + '$1$2');
    }
    return s;
  }

  function parseMoneyToCents(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'string') return Math.round(parseFloat(value) * 100);
    var n = Number(value);
    if (isNaN(n)) return null;
    if (n > 0 && n < 1000) return Math.round(n * 100);
    return Math.round(n);
  }

  function textBlob(p) {
    var tags = p && p.tags;
    var tagStr = Array.isArray(tags) ? tags.join(' ') : String(tags || '');
    return ((p.product_type || p.type || '') + ' ' + (p.title || '') + ' ' + (p.handle || '') + ' ' + tagStr).toLowerCase();
  }

  function isJacket(p) {
    return /\b(?:jackets?|coats?|blazers?|parkas?|puffers?|trench(?:es)?|windbreakers?)\b/.test(textBlob(p));
  }

  function productKind(p) {
    function identify(text) {
      if (/\b(?:sweaters?|jumpers?|pullovers?)\b/.test(text)) return 'sweater';
      if (/\bcardigans?\b/.test(text)) return 'cardigan';
      if (/\b(?:shirts?|blouses?)\b/.test(text)) return 'shirt';
      if (/\b(?:dresses|dress|gowns?|jumpsuits?|rompers?)\b/.test(text)) return 'dress';
      if (/\b(?:jackets?|coats?|blazers?|parkas?|puffers?|trench(?:es)?|windbreakers?)\b/.test(text)) return 'jacket';
      if (/\b(?:shoes?|heels?|sandals?|boots?|sneakers?|loafers?|mules?|flats?|wedges?|pumps?|slip-?ons?|footwear)\b/.test(text)) return 'shoes';
      if (/\bskirts?\b/.test(text)) return 'skirt';
      if (/\b(?:pants?|trousers?|jeans?|leggings?)\b/.test(text)) return 'pant';
      if (/\b(?:tops?|tees?|t-shirts?)\b/.test(text)) return 'top';
      return '';
    }
    return identify(String(p && p.title || '').toLowerCase()) ||
      identify(String(p && (p.product_type || p.type) || '').toLowerCase()) || 'other';
  }

  var KIND_STOP = /^(women|womens|woman|the|and|with|from|this|that|for|elegant|flattering|lightweight|stylish|classic|summer|winter|outfit)$/;

  function titleTokens(p) {
    return String((p && p.title) || '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').split(/\s+/).filter(function (w) {
      return w.length > 3 && !KIND_STOP.test(w);
    });
  }

  function similarScore(seed, p) {
    if (!seed || !p) return 0;
    var sk = productKind(seed);
    var pk = productKind(p);
    var score = 0;
    if (sk && pk && sk === pk) score += 80;
    else if (sk === 'dress' && pk === 'dress') score += 80;
    var a = titleTokens(seed);
    var b = titleTokens(p);
    var hits = 0;
    a.forEach(function (w) { if (b.indexOf(w) !== -1) hits += 1; });
    score += hits * 12;
    return score;
  }

  function sortMostSimilar(pool, seed) {
    return (pool || []).slice().sort(function (a, b) {
      return similarScore(seed, b) - similarScore(seed, a);
    });
  }

  function isShoe(p) {
    var t = textBlob(p).replace(/flatter(?:ing)?/g, ' ');
    return /\b(?:shoes?|heels?|sandals?|boots?|sneakers?|loafers?|mules?|flats?|wedges?|pumps?|slip-?ons?|footwear)\b/.test(t);
  }

  function isDress(p) {
    return /\b(?:dress(?:es)?|gowns?|jumpsuits?|rompers?|maxi|midi)\b/.test(textBlob(p));
  }

  function isClothes(p) {
    if (isShoe(p)) return false;
    return /top|blouse|skirt|pant|jean|trouser|set|outfit|coat|jacket|sweater|knit|shirt|tee|cardigan|vest|short|legging|clothes|apparel/.test(textBlob(p)) || isDress(p);
  }

  function isAvailable(p) {
    if (!p || !p.variants || !p.variants.length) return false;
    return p.variants.some(function (v) { return v.available !== false; });
  }

  function minPrice(p) {
    var min = Infinity;
    (p.variants || []).forEach(function (v) {
      if (v.available === false) return;
      var c = Number(v.price);
      if (c < min) min = c;
    });
    return min === Infinity ? 0 : min;
  }

  function normalizeCollectionProduct(raw, pool) {
    var variants = (raw.variants || []).map(function (v) {
      return {
        id: v.id,
        title: v.title,
        available: v.available !== false,
        price: pool === 'rec' ? Number(v.price) || 0 : parseMoneyToCents(v.price) || 0,
        compare_at_price: pool === 'rec' ? Number(v.compare_at_price) || null : parseMoneyToCents(v.compare_at_price),
        option1: v.option1,
        option2: v.option2,
        option3: v.option3,
        featured_image: v.featured_image
      };
    });
    var images = (raw.images || []).map(function (img) {
      return typeof img === 'string' ? img : (img && img.src) || '';
    }).filter(Boolean);
    var featured = raw.featured_image;
    if (featured && typeof featured === 'object') featured = featured.src || '';
    if (!featured && images[0]) featured = images[0];
    var options = raw.options || [];
    if (options.length && typeof options[0] === 'object') {
      options = options.map(function (o) { return o.name || o; });
    }
    return {
      id: raw.id,
      handle: raw.handle,
      title: raw.title,
      product_type: raw.product_type || raw.type || '',
      tags: raw.tags || [],
      url: raw.url || ('/products/' + raw.handle),
      featured_image: featured,
      images: images,
      options: options,
      variants: variants,
      description: raw.description || raw.body_html || '',
      _pool: pool || ''
    };
  }

  function normalizeRecProduct(raw) {
    return normalizeCollectionProduct(raw, 'rec');
  }

  function fetchCollection(handle, pool) {
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        return (data.products || []).map(function (p) {
          return normalizeCollectionProduct(p, pool);
        });
      })
      .catch(function () { return []; });
  }

  function fetchComplementary(productId) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=complementary', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { return (data && data.products) ? data.products : []; })
      .catch(function () { return []; });
  }

  function fetchRelated(productId) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { return (data && data.products) ? data.products : []; })
      .catch(function () { return []; });
  }

  function dedupe(list) {
    var seen = {};
    return (list || []).filter(function (p) {
      if (!p || seen[String(p.id)]) return false;
      seen[String(p.id)] = true;
      return true;
    });
  }

  function getBundleProgress(itemCount) {
    var current = null;
    var next = BUNDLE_TIERS[0];
    for (var i = 0; i < BUNDLE_TIERS.length; i++) {
      if (itemCount >= BUNDLE_TIERS[i].min) current = BUNDLE_TIERS[i];
      if (itemCount < BUNDLE_TIERS[i].min) {
        next = BUNDLE_TIERS[i];
        break;
      }
      if (i === BUNDLE_TIERS.length - 1) next = null;
    }
    var maxTier = BUNDLE_TIERS[BUNDLE_TIERS.length - 1];
    var progress = Math.min(100, (itemCount / maxTier.min) * 100);
    return { current: current, next: next, progress: progress, max: maxTier.min };
  }

  /* ─── Add and save (FBT) ─── */
  var SuteraaFBT = {
    root: null,
    list: null,
    totalEl: null,
    refreshBtn: null,
    preview: null,
    statusEl: null,
    ladderFill: null,
    tierEls: null,
    productId: null,
    mainPrice: 0,
    mode: 'clothes',
    anchorNoun: 'look',
    shoePool: [],
    dressPool: [],
    clothesPool: [],
    products: [],
    matchedPool: [],
    loosePool: [],
    pool: [],
    selectedByIndex: {},
    page: 0,
    previewProduct: null,
    previewSelected: {},
    previewImgIdx: 0,
    previewRowIndex: null,

    ROLE_PHRASE: {
      dress: 'a dress',
      jacket: 'a jacket',
      shoe: 'a pair of shoes',
      shoes: 'a pair of shoes',
      clothes: 'another piece',
      similar: 'a similar piece'
    },

    init: function () {
      this.root = document.querySelector('[data-st-fbt]');
      if (!this.root || this.root.dataset.stFbtReady === 'true') return;
      this.root.dataset.stFbtReady = 'true';
      this.list = this.root.querySelector('[data-st-fbt-list]');
      this.totalEl = this.root.querySelector('[data-st-fbt-total]');
      this.refreshBtn = this.root.querySelector('[data-st-fbt-refresh]');
      this.statusEl = this.root.querySelector('[data-st-fbt-status]');
      this.ladderFill = this.root.querySelector('[data-st-fbt-ladder-fill]');
      this.tierEls = this.root.querySelectorAll('[data-st-fbt-tier]');
      this.preview = document.querySelector('[data-st-fbt-preview]');
      this.mainPrice = parseInt(this.root.getAttribute('data-main-price'), 10) || 0;
      this.productId = this.root.getAttribute('data-product-id');
      this.mode = this.root.getAttribute('data-mode') || 'clothes';
      this.anchorNoun = this.root.getAttribute('data-anchor-noun') || 'look';
      this.seed = {
        id: this.productId,
        title: this.root.getAttribute('data-seed-title') || '',
        product_type: this.root.getAttribute('data-seed-type') || '',
        tags: (this.root.getAttribute('data-collections') || '').split(',')
      };
      if (!this.productId) return;

      var self = this;
      document.addEventListener('st:variant-updated', function (e) {
        var priceEl = document.querySelector('[data-price]');
        if (priceEl) {
          var raw = (priceEl.textContent || '').replace(/[^0-9.]/g, '');
          var dollars = parseFloat(raw);
          if (!isNaN(dollars)) self.mainPrice = Math.round(dollars * 100);
        }
        self.updateTotal();
      });

      if (this.refreshBtn) {
        this.refreshBtn.addEventListener('click', function () { self.refresh(); });
      }

      this.bindQtyListeners();

      if (this.preview) {
        this.preview.querySelectorAll('[data-st-fbt-pv-close]').forEach(function (el) {
          el.addEventListener('click', function () { self.closePreview(); });
        });
        var prev = this.preview.querySelector('[data-st-fbt-pv-prev]');
        var next = this.preview.querySelector('[data-st-fbt-pv-next]');
        if (prev) prev.addEventListener('click', function () { self.shiftPreviewImage(-1); });
        if (next) next.addEventListener('click', function () { self.shiftPreviewImage(1); });
        var atc = this.preview.querySelector('[data-st-fbt-pv-atc]');
        var stack = this.preview.querySelector('[data-st-fbt-pv-stack]');
        if (atc) atc.addEventListener('click', function () { self.previewAddToCart(); });
        if (stack) stack.addEventListener('click', function () { self.previewAddToStack(); });
        window.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.preview.classList.contains('is-open')) self.closePreview();
        });
      }

      this.load();
    },

    pushPool: function (p) {
      if (!p || String(p.id) === String(this.productId) || !isAvailable(p)) return;
      var seedKind = productKind(this.seed), kind = productKind(p);
      function typeName(type) { return String(type || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
      var seedType = typeName(this.seed.product_type), candidateType = typeName(p.product_type);
      var broadType = /^(?:apparel|clothing|clothes|fashion|products|men|women|mens|womens|tops)$/;
      var preciseType = seedType && !broadType.test(seedType);
      function audience(item) {
        var text = String(item.title || '') + ' ' + String(item.product_type || '');
        text = text.toLowerCase();
        if (/\b(?:women|womens|woman|ladies|female)\b/.test(text)) return 'women';
        if (/\b(?:men|mens|man|male)\b/.test(text)) return 'men';
        return '';
      }
      if (audience(this.seed) && audience(p) && audience(this.seed) !== audience(p)) return;
      var strict = true;
      if (preciseType && candidateType && !broadType.test(candidateType)) {
        if (seedType !== candidateType) strict = false;
      } else if (seedKind === 'other' || kind !== seedKind) strict = false;
      if (seedKind !== 'other' && kind !== 'other' && seedKind !== kind) strict = false;
      if (strict) this.matchedPool.push(p);
      else if (seedKind !== 'other' && kind !== 'other') this.loosePool.push(p);
    },

    load: function () {
      var self = this;
      self.matchedPool = [];
      self.loosePool = [];
      var inline = document.querySelector('[data-st-fbt-seed-products]');
      if (inline) {
        try { JSON.parse(inline.textContent).forEach(function (p) { self.pushPool(normalizeRecProduct(p)); }); }
        catch (e) { /* Remote sources remain available if editor data is incomplete. */ }
      }
      function showMatches() {
        self.matchedPool = sortMostSimilar(dedupe(self.matchedPool), self.seed);
        self.pool = self.matchedPool;
        if (self.pool.length < 3) {
          var strictIds = {};
          self.pool.forEach(function (p) { strictIds[String(p.id)] = true; });
          self.pool = self.pool.concat(sortMostSimilar(dedupe(self.loosePool), self.seed).filter(function (p) { return !strictIds[String(p.id)]; }));
        }
        self.applyPage();
        self.root.hidden = !self.products.length;
        self.updateTotal();
      }
      showMatches();
      var handles = (self.root.getAttribute('data-collections') || '').split(',').filter(Boolean).slice(0, 8);
      var requests = handles.map(function (handle) { return fetchCollection(encodeURIComponent(handle), 'category'); });
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var query = self.seed.product_type ? 'product_type:' + JSON.stringify(self.seed.product_type) : self.seed.title;
      requests.push(fetch(base + 'search?type=product&q=' + encodeURIComponent(query) + '&section_id=aw-bundle-candidates', { credentials: 'same-origin' })
        .then(function(r) { if (!r.ok) return []; return r.text(); })
        .then(function(html) { if (!html) return []; var doc = new DOMParser().parseFromString(html, 'text/html'); var data = doc.querySelector('[data-aw-bundle-candidates]'); return data ? JSON.parse(data.textContent).map(normalizeRecProduct) : []; })
        .catch(function() { return []; }));
      requests.push(fetchRelated(self.productId).then(function(products) { return products.map(normalizeRecProduct); }));
      Promise.all(requests).then(function(results) {
        results.forEach(function(products) { (products || []).forEach(function(p) { self.pushPool(p); }); });
        // Keep shoppers' selected bundle items in place while background sources finish loading.
        if (!self.getSelectedItems().length && !self.preview.classList.contains('is-open')) showMatches();
        if (self.matchedPool.length < 3 && self.loosePool.length < 3) {
          var page = 1;
          function moreCatalog() {
            return fetch(base + 'products.json?limit=250&page=' + page, { credentials: 'same-origin' })
              .then(function(r) { if (!r.ok) return { products: [] }; return r.json(); })
              .then(function(data) {
                var products = data.products || [];
                products.forEach(function(p) { self.pushPool(normalizeCollectionProduct(p, 'catalog')); });
                if (!self.getSelectedItems().length && !self.preview.classList.contains('is-open')) showMatches();
                if (products.length === 250 && self.pool.length < 6 && page < 12) { page += 1; return moreCatalog(); }
              }).catch(function() { /* Retain already-rendered collection matches. */ });
          }
          moreCatalog();
        }
      });
    },

    pickSet: function () {
      var pool = this.pool || [];
      var picked = [], start = pool.length ? (this.page * 3) % pool.length : 0;
      for (var i = 0; i < pool.length && picked.length < 3; i++) {
        var p = pool[(start + i) % pool.length];
        p._role = productKind(p);
        picked.push(p);
      }
      return picked;
    },

    applyPage: function () {
      this.products = this.pickSet();
      this.selectedByIndex = {};
      var self = this;
      this.products.forEach(function (p, i) {
        var v = null;
        for (var n = 0; n < p.variants.length; n++) {
          if (p.variants[n].available !== false) { v = p.variants[n]; break; }
        }
        self.selectedByIndex[i] = v || p.variants[0];
      });
      this.render();
    },

    refresh: function () {
      var self = this;
      if (this.refreshBtn) {
        this.refreshBtn.classList.add('is-spinning');
        setTimeout(function () { self.refreshBtn.classList.remove('is-spinning'); }, 550);
      }
      this.page += 1;
      this.applyPage();
    },

    imageUrl: function (product, variant) {
      var url = '';
      if (variant && variant.featured_image) {
        url = typeof variant.featured_image === 'string'
          ? variant.featured_image
          : (variant.featured_image.src || '');
      }
      if (!url && product.featured_image) url = product.featured_image;
      if (!url && product.images && product.images[0]) url = product.images[0];
      return getSizedImage(url, '160x') || url;
    },

    optionValues: function (product, pos) {
      var values = [];
      (product.variants || []).forEach(function (v) {
        var val = v['option' + pos];
        if (val && values.indexOf(val) === -1) values.push(val);
      });
      return values;
    },

    findVariantForOptions: function (product, selected) {
      return (product.variants || []).find(function (v) {
        for (var i = 1; i <= (product.options || []).length; i++) {
          if (selected[i] && v['option' + i] !== selected[i]) return false;
        }
        return true;
      }) || null;
    },

    priceHtml: function (variant) {
      if (!variant) return '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return '<s>' + money(variant.compare_at_price) + '</s>' + money(variant.price);
      }
      return money(variant.price);
    },

    sizeButtonsHtml: function (product, index, current) {
      var options = product.options || [];
      var sizePos = 1;
      for (var i = 0; i < options.length; i++) {
        if (/size|eu|us|width/i.test(String(options[i]))) {
          sizePos = i + 1;
          break;
        }
      }
      var values = this.optionValues(product, sizePos);
      if (values.length <= 1 || values.length > 8 || options.length > 1) {
        return '<button type="button" class="st-fbt__more" data-st-fbt-preview-btn data-index="' + index + '">Select size / preview</button>';
      }
      var html = '<div class="st-fbt__sizes" data-st-fbt-sizes data-index="' + index + '" data-pos="' + sizePos + '">';
      values.forEach(function (val) {
        var match = (product.variants || []).find(function (v) {
          return v['option' + sizePos] === val && v.available !== false;
        });
        var any = (product.variants || []).find(function (v) { return v['option' + sizePos] === val; });
        var target = match || any;
        if (!target) return;
        var pressed = current && current['option' + sizePos] === val;
        html += '<button type="button" class="st-fbt__size' + (!match ? ' is-unavailable' : '') + '" data-value="' +
          esc(val) + '" data-variant-id="' + target.id + '" data-price="' + target.price + '" aria-pressed="' +
          (pressed ? 'true' : 'false') + '"' + (!match ? ' disabled' : '') + '>' + esc(val) + '</button>';
      });
      html += '</div>';
      return html;
    },

    badgeFor: function (product) {
      var kind = product._role || productKind(product);
      if (kind === 'shoe' || kind === 'shoes') return 'Shoes';
      if (kind === 'dress') return 'Dress';
      if (kind === 'jacket') return 'Jacket';
      return 'Similar';
    },

    render: function () {
      var self = this;
      if (!this.list) return;
      if (!this.products.length) {
        this.list.innerHTML = '<p class="st-fbt__loading">No pairings right now. Try Refresh.</p>';
        return;
      }
      var html = '';
      this.products.forEach(function (product, index) {
        var current = self.selectedByIndex[index] || product.variants[0];
        var img = self.imageUrl(product, current);
        var isFeature = false;
        html +=
          '<div class="st-fbt__row' + (isFeature ? ' is-feature' : '') + '">' +
            '<input type="checkbox" class="st-fbt__check" data-st-fbt-check data-index="' + index + '" data-variant-id="' + current.id + '" data-price="' + current.price + '"' + (current.available === false ? ' disabled' : '') + '>' +
            '<button type="button" class="st-fbt__thumb-wrap" data-st-fbt-preview-btn data-index="' + index + '" aria-label="Preview ' + esc(product.title) + '">' +
              '<img class="st-fbt__thumb" data-st-fbt-thumb data-index="' + index + '" src="' + esc(img) + '" alt="" width="64" height="85" loading="lazy">' +
              '<span class="st-fbt__preview-cue">Preview</span>' +
            '</button>' +
            '<div class="st-fbt__meta">' +
              '<span class="st-fbt__badge">' + esc(self.badgeFor(product)) + '</span>' +
              '<div class="st-fbt__top">' +
                '<button type="button" class="st-fbt__name" data-st-fbt-preview-btn data-index="' + index + '">' + esc(product.title) + '</button>' +
                '<span class="st-fbt__price" data-st-fbt-price data-index="' + index + '">' + self.priceHtml(current) + '</span>' +
              '</div>' +
              self.sizeButtonsHtml(product, index, current) +
            '</div>' +
          '</div>';
      });
      this.list.innerHTML = html;
      this.bindRowEvents();
      this.updateTotal();
    },

    bindRowEvents: function () {
      var self = this;
      this.list.querySelectorAll('[data-st-fbt-check]').forEach(function (cb) {
        cb.indeterminate = false;
        cb.addEventListener('change', function () {
          cb.indeterminate = false;
          self.updateTotal();
        });
      });
      this.list.querySelectorAll('[data-st-fbt-preview-btn]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.openPreview(parseInt(btn.getAttribute('data-index'), 10));
        });
      });
      this.list.querySelectorAll('.st-fbt__size').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var wrap = btn.closest('[data-st-fbt-sizes]');
          var idx = parseInt(wrap.getAttribute('data-index'), 10);
          var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
          var price = parseInt(btn.getAttribute('data-price'), 10);
          wrap.querySelectorAll('.st-fbt__size').forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var match = (self.products[idx].variants || []).find(function (v) {
            return String(v.id) === String(vid);
          });
          if (match) self.selectedByIndex[idx] = match;
          var check = self.list.querySelector('[data-st-fbt-check][data-index="' + idx + '"]');
          if (check) {
            check.setAttribute('data-variant-id', String(vid));
            check.setAttribute('data-price', String(price));
          }
          var priceEl = self.list.querySelector('[data-st-fbt-price][data-index="' + idx + '"]');
          if (priceEl && match) priceEl.innerHTML = self.priceHtml(match);
          var thumb = self.list.querySelector('[data-st-fbt-thumb][data-index="' + idx + '"]');
          if (thumb && match) thumb.src = self.imageUrl(self.products[idx], match);
          self.updateTotal();
        });
      });
    },

    openPreview: function (index) {
      if (!this.preview || !this.products[index]) return;
      this.previewRowIndex = index;
      this.previewProduct = this.products[index];
      this.previewImgIdx = 0;
      this.previewSelected = {};
      var current = this.selectedByIndex[index];
      var opts = this.previewProduct.options || [];
      for (var i = 1; i <= opts.length; i++) {
        this.previewSelected[i] = current ? current['option' + i] : null;
      }
      this.preview.querySelector('[data-st-fbt-pv-title]').textContent = this.previewProduct.title;
      var desc = this.preview.querySelector('[data-st-fbt-pv-desc]');
      var rawDesc = (this.previewProduct.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      desc.textContent = rawDesc ? rawDesc.slice(0, 220) : 'See full details on the product page.';
      this.renderPreviewThumbs();
      this.renderPreviewOptions();
      this.syncPreviewVariant();
      this.preview.classList.add('is-open');
      this.preview.setAttribute('aria-hidden', 'false');
      document.body.classList.add('st-fbt-preview-open');
      document.body.style.overflow = 'hidden';
      var scroll = this.preview.querySelector('.st-fbt-pv__scroll');
      if (scroll) scroll.scrollTop = 0;
    },

    renderPreviewThumbs: function () {
      var self = this;
      var product = this.previewProduct;
      var thumbs = this.preview.querySelector('[data-st-fbt-pv-thumbs]');
      var images = product.images && product.images.length ? product.images : [product.featured_image].filter(Boolean);
      product._previewImages = images;
      thumbs.innerHTML = images.map(function (src, i) {
        return '<button type="button" class="st-fbt-pv__thumb' + (i === self.previewImgIdx ? ' is-active' : '') + '" data-img-idx="' + i + '">' +
          '<img src="' + esc(getSizedImage(src, '120x') || src) + '" alt="" loading="lazy">' +
          '</button>';
      }).join('');
      thumbs.querySelectorAll('[data-img-idx]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.previewImgIdx = parseInt(btn.getAttribute('data-img-idx'), 10);
          self.updatePreviewImage();
        });
      });
      this.updatePreviewImage();
    },

    updatePreviewImage: function () {
      var images = (this.previewProduct && this.previewProduct._previewImages) || [];
      if (!images.length) return;
      if (this.previewImgIdx < 0) this.previewImgIdx = images.length - 1;
      if (this.previewImgIdx >= images.length) this.previewImgIdx = 0;
      var src = images[this.previewImgIdx];
      var img = this.preview.querySelector('[data-st-fbt-pv-img]');
      img.src = src + (src.indexOf('?') === -1 ? '?width=1200' : '&width=1200');
      img.alt = this.previewProduct.title;
      this.preview.querySelector('[data-st-fbt-pv-counter]').textContent =
        (this.previewImgIdx + 1) + ' / ' + images.length;
      var self = this;
      this.preview.querySelectorAll('.st-fbt-pv__thumb').forEach(function (t, i) {
        t.classList.toggle('is-active', i === self.previewImgIdx);
      });
    },

    shiftPreviewImage: function (delta) {
      this.previewImgIdx += delta;
      this.updatePreviewImage();
    },

    renderPreviewOptions: function () {
      var self = this;
      var product = this.previewProduct;
      var wrap = this.preview.querySelector('[data-st-fbt-pv-options]');
      if (!product.options || !product.options.length ||
          (product.variants.length === 1 && product.variants[0].title === 'Default Title')) {
        wrap.innerHTML = '';
        return;
      }
      var html = '';
      product.options.forEach(function (optName, idx) {
        var pos = idx + 1;
        var values = self.optionValues(product, pos);
        html += '<div class="st-fbt-pv__group" data-st-fbt-pv-group data-pos="' + pos + '">' +
          '<p class="st-fbt-pv__opt-label">' + esc(String(optName)) +
          ': <strong data-st-fbt-pv-selected>' + esc(self.previewSelected[pos] || '') + '</strong></p>' +
          '<div class="st-fbt-pv__values">';
        values.forEach(function (val) {
          var available = (product.variants || []).some(function (v) {
            return v['option' + pos] === val && v.available !== false;
          });
          var pressed = self.previewSelected[pos] === val;
          html += '<button type="button" class="st-fbt-pv__val' + (!available ? ' is-unavailable' : '') +
            '" data-pos="' + pos + '" data-value="' + esc(val) + '" aria-pressed="' +
            (pressed ? 'true' : 'false') + '"' + (!available ? ' disabled' : '') + '>' +
            esc(val) + '</button>';
        });
        html += '</div></div>';
      });
      wrap.innerHTML = html;
      wrap.querySelectorAll('.st-fbt-pv__val').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var pos = btn.getAttribute('data-pos');
          self.previewSelected[pos] = btn.getAttribute('data-value');
          var group = btn.closest('[data-st-fbt-pv-group]');
          group.querySelectorAll('.st-fbt-pv__val').forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var label = group.querySelector('[data-st-fbt-pv-selected]');
          if (label) label.textContent = btn.getAttribute('data-value');
          self.syncPreviewVariant();
        });
      });
    },

    syncPreviewVariant: function () {
      var v = this.findVariantForOptions(this.previewProduct, this.previewSelected);
      var priceEl = this.preview.querySelector('[data-st-fbt-pv-price]');
      var atc = this.preview.querySelector('[data-st-fbt-pv-atc]');
      if (!v) {
        atc.disabled = true;
        atc.textContent = 'Unavailable';
        return;
      }
      priceEl.innerHTML = this.priceHtml(v);
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to Cart' : 'Sold Out';
    },

    previewCurrentVariant: function () {
      return this.findVariantForOptions(this.previewProduct, this.previewSelected);
    },

    previewAddToCart: function () {
      var v = this.previewCurrentVariant();
      if (!v || !v.available) return;
      var self = this;
      var atc = this.preview.querySelector('[data-st-fbt-pv-atc]');
      atc.disabled = true;
      atc.textContent = 'Adding…';
      if (window.stCartDrawer && typeof window.stCartDrawer.addItems === 'function') {
        window.stCartDrawer.addItems([{ id: v.id, quantity: 1 }], false, { skipComplete: false }).then(function () {
          self.closePreview();
          atc.disabled = false;
          atc.textContent = 'Add to Cart';
        }).catch(function () {
          atc.disabled = false;
          atc.textContent = 'Try again';
        });
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: 1 })
        }).then(function () {
          self.closePreview();
          if (window.stCartDrawer) window.stCartDrawer.open();
          atc.disabled = false;
          atc.textContent = 'Add to Cart';
        });
      }
    },

    previewAddToStack: function () {
      var v = this.previewCurrentVariant();
      if (!v || this.previewRowIndex == null) return;
      var idx = this.previewRowIndex;
      var rowProduct = this.products[idx];
      var match = rowProduct && (rowProduct.variants || []).find(function (rv) {
        return String(rv.id) === String(v.id);
      });
      this.selectedByIndex[idx] = match || v;
      this.render();
      var check = this.list.querySelector('[data-st-fbt-check][data-index="' + idx + '"]');
      if (check) {
        check.indeterminate = false;
        check.checked = true;
        check.setAttribute('data-variant-id', String(v.id));
        check.setAttribute('data-price', String(v.price));
      }
      this.updateTotal();
      this.closePreview();
    },

    closePreview: function () {
      if (!this.preview) return;
      this.preview.classList.remove('is-open');
      this.preview.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('st-fbt-preview-open');
      var drawer = document.getElementById('st-cd');
      if (!drawer || !drawer.classList.contains('is-open')) {
        document.body.style.overflow = '';
      }
    },

    getSelectedItems: function () {
      if (!this.list) return [];
      var items = [];
      this.list.querySelectorAll('[data-st-fbt-check]:checked').forEach(function (cb) {
        var id = parseInt(cb.getAttribute('data-variant-id'), 10);
        if (id) items.push({ id: id, quantity: 1 });
      });
      return items;
    },

    clearSelected: function () {
      if (!this.list) return;
      this.list.querySelectorAll('[data-st-fbt-check]:checked').forEach(function (cb) {
        cb.indeterminate = false;
        cb.checked = false;
      });
      this.updateTotal();
    },

    mainQty: function () {
      /* Prefer the PDP stepper; avoid sticky/hidden duplicates. */
      var input =
        document.querySelector('[data-st-qty]') ||
        document.querySelector('[data-pdp-qty-input]') ||
        document.querySelector('.st-pdp-qty__input') ||
        document.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
        document.querySelector('input[name="quantity"]');
      var q = input ? parseInt(input.value, 10) : 1;
      if (!q || q < 1) q = 1;
      if (q > 99) q = 99;
      return q;
    },

    bindQtyListeners: function () {
      var self = this;
      function onQty() { self.updateTotal(); }
      document.addEventListener('st:qty-updated', onQty);
      document.addEventListener('st:sticky-qty', onQty);
      function bindInputs() {
        document.querySelectorAll('[data-st-qty], [data-pdp-qty-input], .st-pdp-qty__input, form[action*="/cart/add"] input[name="quantity"]').forEach(function (input) {
          if (input._stFbtQtyBound) return;
          input._stFbtQtyBound = true;
          input.addEventListener('input', onQty);
          input.addEventListener('change', onQty);
        });
        document.querySelectorAll('[data-st-qty-minus], [data-st-qty-plus], [data-st-sticky-qty-minus], [data-st-sticky-qty-plus]').forEach(function (btn) {
          if (btn._stFbtQtyBound) return;
          btn._stFbtQtyBound = true;
          btn.addEventListener('click', function () { setTimeout(onQty, 0); });
        });
      }
      bindInputs();
      /* Sticky ATC mounts late; re-bind once after paint. */
      setTimeout(bindInputs, 400);
    },

    /* Dynamic copy: names what is on offer next to this anchor, e.g.
       "Add a dress or another piece with this look and 10% comes off everything at checkout." */
    pairingSentence: function (pct) {
      var self = this;
      var roles = [];
      (this.products || []).forEach(function (p) {
        var role = p._role || productKind(p);
        if (role && roles.indexOf(role) === -1) roles.push(role);
      });
      var phrases = roles.map(function (r) {
        if (r === self.mode || (r === 'dress' && self.mode === 'dress')) return 'another dress';
        if (r === 'jacket' && self.mode === 'jacket') return 'another jacket';
        if ((r === 'shoe' || r === 'shoes') && self.mode === 'shoes') return 'another pair';
        return self.ROLE_PHRASE[r] || self.ROLE_PHRASE.similar;
      }).filter(Boolean).slice(0, 2);
      var what = phrases.length ? phrases.join(' or ') : 'another piece';
      return 'Add ' + what + ' with this ' + this.anchorNoun + ' and <span>' + pct + '% comes off everything</span> at checkout.';
    },

    renderLadder: function (count) {
      var state = getBundleProgress(count);
      if (this.ladderFill) this.ladderFill.style.width = Math.max(12, state.progress) + '%';
      if (this.tierEls && this.tierEls.length) {
        var nextMin = state.next ? state.next.min : null;
        this.tierEls.forEach(function (el) {
          var min = parseInt(el.getAttribute('data-st-fbt-tier'), 10);
          el.classList.toggle('is-unlocked', count >= min);
          el.classList.toggle('is-next', nextMin === min);
        });
      }
      if (this.statusEl) {
        var msg;
        if (!state.next && state.current) {
          msg = 'Maximum savings: <span>' + state.current.pct + '% off everything</span> at checkout.';
        } else if (state.current) {
          var need = state.next.min - count;
          msg = '<span>' + state.current.pct + '% off everything</span> unlocked. Add ' + need + ' more for <span>' + state.next.pct + '% off</span>.';
        } else {
          msg = this.pairingSentence(state.next ? state.next.pct : 10);
        }
        this.statusEl.innerHTML = msg;
        this.statusEl.classList.toggle('is-max', !state.next);
      }
    },

    updateTotal: function () {
      if (!this.root) return;
      /* Units = main PDP qty + each checked add-on (qty 1 each). Prices in cents. */
      var extras = 0;
      var picked = 0;
      if (this.list) {
        this.list.querySelectorAll('[data-st-fbt-check]:checked').forEach(function (cb) {
          if (cb.disabled) return;
          extras += parseInt(cb.getAttribute('data-price'), 10) || 0;
          picked += 1;
        });
      }
      var mainQty = this.mainQty();
      var count = mainQty + picked;
      this.renderLadder(count);
      document.dispatchEvent(new CustomEvent("st:bundle-selection-updated"));
      if (!this.totalEl) return;
      if (picked === 0) {
        this.totalEl.hidden = true;
        return;
      }
      var mainCents = Math.round(Number(this.mainPrice) || 0);
      var total = (mainCents * mainQty) + extras;
      var itemLabel = count === 1 ? '1 item' : (count + ' items');
      this.totalEl.hidden = false;
      this.totalEl.innerHTML = 'Look total: <span>' + money(total) + '</span> · ' + itemLabel + '. Bundle savings at checkout';
    }
  };

  /* ─── Complete your order (post-ATC) ─── */
  var SuteraaCompleteOrder = {
    root: null,
    list: null,
    tierEl: null,
    addBtn: null,
    pool: [],
    selected: {},
    pendingCart: null,
    skipOpen: false,

    init: function () {
      this.root = document.querySelector('[data-st-complete]');
      if (!this.root) return;
      this.list = this.root.querySelector('[data-st-complete-list]');
      this.tierEl = this.root.querySelector('[data-st-complete-tier]');
      this.addBtn = this.root.querySelector('[data-st-complete-add]');
      var self = this;
      this.root.querySelectorAll('[data-st-complete-skip]').forEach(function (el) {
        el.addEventListener('click', function () { self.finish(false); });
      });
      if (this.addBtn) {
        this.addBtn.addEventListener('click', function () { self.finish(true); });
      }
    },

    firstAvailableVariant: function (p) {
      if (!p.variants) return null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available !== false) return p.variants[i];
      }
      return p.variants[0] || null;
    },

    offer: function (cart, opts) {
      var self = this;
      opts = opts || {};
      this.pendingCart = cart;
      this.skipOpen = !!opts.skipOpen;
      this.selected = {};
      if (!this.root || !this.list) {
        if (!this.skipOpen && window.stCartDrawer) window.stCartDrawer.open();
        return Promise.resolve(cart);
      }

      var fbtExtras = (window.SuteraaFBT && typeof window.SuteraaFBT.getSelectedItems === 'function')
        ? window.SuteraaFBT.getSelectedItems()
        : [];
      if (fbtExtras.length > 0) {
        if (typeof window.SuteraaFBT.clearSelected === 'function') window.SuteraaFBT.clearSelected();
        if (!this.skipOpen && window.stCartDrawer) window.stCartDrawer.open();
        return Promise.resolve(cart);
      }

      var state = getBundleProgress(cart.item_count || 0);
      if (this.tierEl) {
        if (state.next) {
          var need = state.next.min - (cart.item_count || 0);
          this.tierEl.hidden = false;
          this.tierEl.innerHTML = 'Add <span>' + need + ' more</span> to unlock <span>' + state.next.pct + '% off</span> at checkout.';
        } else {
          this.tierEl.hidden = true;
        }
      }

      this.list.innerHTML = '<p class="st-complete__loading">Finding pieces that pair well…</p>';

      var inCart = {};
      (cart.items || []).forEach(function (it) {
        if (it.product_id) inCart[String(it.product_id)] = true;
        if (it.handle) inCart[it.handle] = true;
      });

      var seedItem = (cart.items && cart.items.length) ? cart.items[cart.items.length - 1] : null;
      var seedId = (seedItem && seedItem.product_id) || null;
      var seed = {
        id: seedId,
        title: (seedItem && (seedItem.product_title || seedItem.title)) || '',
        product_type: (seedItem && seedItem.product_type) || '',
        handle: (seedItem && seedItem.handle) || '',
        tags: []
      };

      return Promise.all([
        fetchCollection('party-dresses', 'dresses'),
        fetchCollection('summer-outfits', 'dresses'),
        fetchCollection('clothes', 'clothes'),
        fetchCollection('all', 'catalog'),
        fetchCollection('shoes', 'shoes'),
        seedId ? fetchRelated(seedId) : Promise.resolve([]),
        seedId ? fetchComplementary(seedId) : Promise.resolve([])
      ]).then(function (results) {
        var pool = [];
        var seedKind = productKind(seed);
        function consider(p) {
          if (inCart[String(p.id)] || inCart[p.handle]) return;
          if (!(isShoe(p) || isClothes(p) || isDress(p) || isJacket(p))) return;
          var kind = productKind(p);
          var sameKind = kind === seedKind && seedKind !== 'other';
          if (seedKind !== 'other' && !sameKind) return;
          if (!sameKind && minPrice(p) > ADDON_MAX_CENTS) return;
          var v = self.firstAvailableVariant(p);
          if (!v) return;
          pool.push({ product: p, variant: v, score: similarScore(seed, p) });
        }
        (results[0] || []).forEach(function (p) { consider(p); });
        (results[1] || []).forEach(function (p) { consider(p); });
        (results[2] || []).forEach(function (p) { consider(p); });
        (results[3] || []).forEach(function (p) { consider(p); });
        (results[4] || []).forEach(function (p) { consider(p); });
        ;[results[5], results[6]].forEach(function (arr) {
          (arr || []).forEach(function (raw) { consider(normalizeRecProduct(raw)); });
        });
        self.pool = pool
          .filter(function (r) { return r && r.product && r.variant; })
          .reduce(function (acc, row) {
            if (acc._seen[String(row.product.id)]) return acc;
            acc._seen[String(row.product.id)] = true;
            acc.list.push(row);
            return acc;
          }, { _seen: {}, list: [] }).list;

        self.pool.sort(function (a, b) { return (b.score || 0) - (a.score || 0); });

        self.pool = self.pool.slice(0, 3);
        if (!self.pool.length) {
          if (!self.skipOpen && window.stCartDrawer) window.stCartDrawer.open();
          return cart;
        }
        self.renderList();
        self.open();
        return cart;
      });
    },

    renderList: function () {
      var self = this;
      if (!this.pool.length) {
        this.list.innerHTML = '<p class="st-complete__loading">No extras available right now. Continue to bag.</p>';
        if (this.addBtn) this.addBtn.disabled = true;
        return;
      }
      this.list.innerHTML = this.pool.map(function (row, idx) {
        var p = row.product;
        var v = row.variant;
        var img = (p.images && p.images[0]) || p.featured_image || '';
        if (img && typeof img === 'object') img = img.src || '';
        return (
          '<label class="st-complete__item" data-st-complete-item data-idx="' + idx + '">' +
            '<input type="checkbox" class="st-complete__check" data-st-complete-check data-idx="' + idx + '">' +
            '<img src="' + esc(String(img)) + '" alt="" width="64" height="85" loading="lazy">' +
            '<span>' +
              '<p class="st-complete__name">' + esc(p.title) + '</p>' +
              '<p class="st-complete__price">' + money(v.price) + '</p>' +
              '<span class="st-complete__badge">Optional</span>' +
            '</span>' +
          '</label>'
        );
      }).join('');

      this.list.querySelectorAll('[data-st-complete-check]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          var idx = parseInt(cb.getAttribute('data-idx'), 10);
          var item = cb.closest('[data-st-complete-item]');
          if (cb.checked) self.selected[idx] = true;
          else delete self.selected[idx];
          if (item) item.classList.toggle('is-on', cb.checked);
          var count = Object.keys(self.selected).length;
          if (self.addBtn) {
            self.addBtn.disabled = count === 0;
            self.addBtn.textContent = count === 0
              ? 'Add selected extras'
              : (count === 1 ? 'Add 1 extra & continue' : 'Add ' + count + ' extras & continue');
          }
        });
      });
      if (this.addBtn) {
        this.addBtn.disabled = true;
        this.addBtn.textContent = 'Add selected extras';
      }
    },

    open: function () {
      if (!this.root) return;
      this.root.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('st-complete-open');
    },

    close: function () {
      if (!this.root) return;
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('st-complete-open');
    },

    finish: function (withSelected) {
      var self = this;
      var items = [];
      if (withSelected) {
        Object.keys(this.selected).forEach(function (k) {
          var row = self.pool[parseInt(k, 10)];
          if (row && row.variant) items.push({ id: row.variant.id, quantity: 1 });
        });
      }
      this.close();
      if (items.length && window.stCartDrawer && typeof window.stCartDrawer.addItems === 'function') {
        window.stCartDrawer.addItems(items, self.skipOpen, { skipComplete: true }).then(function () {
          if (!self.skipOpen) window.stCartDrawer.open();
        });
      } else if (!this.skipOpen && window.stCartDrawer) {
        window.stCartDrawer.open();
      }
    }
  };

  var SuteraaRecent = {
    KEY: 'st_recent_handles_v1',
    MAX: 12,
    cache: {},

    read: function () {
      try {
        var raw = localStorage.getItem(this.KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list.filter(Boolean) : [];
      } catch (e) {
        return [];
      }
    },

    write: function (list) {
      try {
        localStorage.setItem(this.KEY, JSON.stringify(list.slice(0, this.MAX)));
      } catch (e) {}
    },

    track: function (handle) {
      if (!handle) return;
      var list = this.read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      this.write(list);
    },

    trackFromPage: function () {
      var el = document.querySelector('[data-st-recent-track-handle]');
      if (el) this.track(el.getAttribute('data-st-recent-track-handle'));
      else if (window.meta && meta.product && meta.product.handle) this.track(meta.product.handle);
    },

    fetchProduct: function (handle) {
      var self = this;
      if (this.cache[handle]) return Promise.resolve(this.cache[handle]);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p) self.cache[handle] = p;
          return p;
        })
        .catch(function () { return null; });
    },

    cardHtml: function (p) {
      if (!p) return '';
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && typeof img === 'object') img = img.src || '';
      var price = p.price_min != null ? p.price_min : p.price;
      var compare = p.compare_at_price_min || p.compare_at_price || 0;
      var onSale = compare > price;
      var priceHtml = onSale
        ? '<s>' + money(compare) + '</s><span class="is-sale">' + money(price) + '</span>'
        : '<span>' + money(price) + '</span>';
      var imgSrc = String(img);
      if (imgSrc && imgSrc.indexOf('cdn.shopify.com') !== -1 && imgSrc.indexOf('_600x') === -1) {
        imgSrc = imgSrc.replace(/(\.[a-zA-Z]+)(\?|$)/, '_600x$1$2');
      }
      return (
        '<article class="st-recent__card">' +
          '<a class="st-recent__link" href="/products/' + esc(p.handle) + '">' +
            '<div class="st-recent__img">' +
              (imgSrc ? '<img src="' + esc(imgSrc) + '" alt="" width="400" height="533" loading="lazy">' : '') +
            '</div>' +
            '<h3 class="st-recent__name">' + esc(p.title) + '</h3>' +
            '<p class="st-recent__price">' + priceHtml + '</p>' +
          '</a>' +
        '</article>'
      );
    },

    render: function () {
      var section = document.querySelector('[data-st-recent]');
      var track = document.querySelector('[data-st-recent-track]');
      if (!section || !track) return;
      var current = document.querySelector('[data-st-recent-track-handle]');
      var currentHandle = current ? current.getAttribute('data-st-recent-track-handle') : '';
      var handles = this.read().filter(function (h) { return h && h !== currentHandle; }).slice(0, 8);
      if (!handles.length) {
        section.hidden = true;
        return;
      }
      var self = this;
      Promise.all(handles.map(function (h) { return self.fetchProduct(h); })).then(function (products) {
        var html = products.map(function (p) { return self.cardHtml(p); }).filter(Boolean).join('');
        if (!html) {
          section.hidden = true;
          return;
        }
        track.innerHTML = html;
        section.hidden = false;
      });
    }
  };

  function boot() {
    SuteraaFBT.init();
    SuteraaCompleteOrder.init();
    SuteraaRecent.trackFromPage();
    SuteraaRecent.render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  window.SuteraaFBT = SuteraaFBT;
  window.SuteraaCompleteOrder = SuteraaCompleteOrder;
  window.SuteraaRecent = SuteraaRecent;
})();
